
<div class="modal-header" *ngIf="mode=='modal'">
  Scelta del modello di stampa
  <div class="card-tools">
      <button type="button" class="btn btn-tool" (click)="modalWindow.close()" >
          <i class="fas fa-times"></i>
      </button>
  </div>
</div>

<div class="preview-container">
  <!-- Toolbar dei Controlli -->
  <div *ngIf="templatesAvailables && templatesAvailables.length > 1" class="bg-white p-1">
    <div class="input-group input-group-sm">
      <div *ngIf="mode=='modal'" class="input-group-prepend">
        <span class="input-group-text">Modello di stampa</span>
      </div>
      <select  class="form-control form-control-sm" [(ngModel)]="template" (ngModelChange)="renderTemplate()">
        <option *ngFor="let t of templatesAvailables" [ngValue]="t">{{t.name}}</option>
      </select>
    </div>    
  </div>

  <div *ngIf="template" class="preview-toolbar">
     <button type="button" class="btn  btn-primary" (click)="renderTemplate()" title="Aggiorna">
     <i class="fas fa-sync"></i><span class="d-none d-xl-inline ml-1">Aggiorna</span>
    </button>
    <button type="button" class="btn  btn-secondary" (click)="zoomOut()" [disabled]="zoomLevel <= 0.3" title="Riduci"><i class="fas fa-search-minus"></i></button>
    <small class="zoom-value text-gray">{{ (zoomLevel * 100) | number:'1.0-0' }}%</small>
    <button type="button" class="btn  btn-secondary" (click)="zoomIn()" [disabled]="zoomLevel >= 2.0" title="Ingrandisci"><i class="fas fa-search-plus"></i></button>
    <button type="button" class="btn  btn-secondary text-xs d-none d-xl-inline" (click)="resetZoom()" title="Ripristina">100%</button>
    <button type="button" class="btn  btn-warning" (click)="printDocument()" title="Stampa Documento">
      <i class="fas fa-print"></i><span class="d-none d-xl-inline ml-1">Stampa</span>
    </button>
    <!--
    <button type="button" class="btn btn-sm btn-secondary" (click)="downloadPdf()" title="Esporta in PDF il documento">
      <i class="fas fa-save mr-1"></i>PDF
    </button>
   -->
  </div>

  <div *ngIf="!template" class="w-100 text-center alert-danger">Nessun modello presente!</div>

  <!-- Contenitore con scrollbar isolata e iframe -->
  <div class="iframe-viewport">
    
    <iframe id="iframeArea" #iframeArea title="Anteprima"></iframe>
  </div>

   <!-- <div *ngIf="!template" class="iframe-viewport align-items-center">
    <span>Nessun modello presente!</span>
  </div> -->

</div>